import React from 'react';
import PropTypes from 'prop-types';
import styles from './ProgressBar.module.css';

/**
 * ProgressBar - Step progress indicator
 * 
 * Shows progress through the onboarding steps with:
 * - Animated fill
 * - Step indicators
 * - Progress percentage
 */
export function ProgressBar({ currentStep, totalSteps }) {
  const progress = Math.min((currentStep / totalSteps) * 100, 100);

  return (
    <div className={styles.container}>
      <div className={styles.progressTrack}>
        <div 
          className={styles.progressFill}
          style={{ width: `${progress}%` }}
          aria-hidden="true"
        />
      </div>
      
      {/* Step indicators */}
      <div className={styles.steps}>
        {Array.from({ length: totalSteps }, (_, index) => {
          const stepNumber = index + 1;
          const isActive = stepNumber <= currentStep;
          const isCurrent = stepNumber === currentStep;

          return (
            <div
              key={stepNumber}
              className={`${styles.step} ${isActive ? styles.stepActive : ''} ${isCurrent ? styles.stepCurrent : ''}`}
              aria-current={isCurrent ? 'step' : undefined}
            >
              <div className={styles.stepDot} />
            </div>
          );
        })}
      </div>

      {/* Screen reader text */}
      <span className={styles.srOnly}>
        Step {currentStep} of {totalSteps}
      </span>
    </div>
  );
}

ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

export default ProgressBar;
